module.exports = __webpack_public_path__ + "static/media/logos-print-spacciatore.351ccc48.jpg";